const zxcvbn = require('zxcvbn');
export default {
  required (name) {
    return v => !!v || `${name} is required`
  },
  password: [
    v => (v && v.length >= 8) || 'The password must have at least 8 characters'
  ],
  confirm_password: (v, password) => {
    return (v && v === password) || 'The password does not match'
  },
  number (name) {
    return v => isFinite(v) || `${name} has to be a number`
  },
  different_password: (v, old_password) => {
    return (v && v !== old_password) || 'The new password must be different from the old one'
  },
  check_simple_password: (v) => {
    if (v === null || v === undefined) {
      v = '';
  }
    const ret = zxcvbn(v);
    let result;

    if (ret.score >= 3) {
        result = ret.score;
    } else if (ret.feedback && ret.feedback.warning) {
        result = ret.feedback.warning;
    } else if (ret.feedback && ret.feedback.suggestions && ret.feedback.suggestions[0]) {
        result = true;
    } else {
        result = ret.feedback.suggestions[0];
    }

    return result;
  },
  password_strong: (value) => {
    //var regularExpression = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    //var regularExpression = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!£@#$%^&*()_\-+=\[\]{};:'",.<>?/\\|`~])[A-Za-z\d!£@#$%^&*()_\-+=\[\]{};:'",.<>?/\\|`~]{8,}$/;
    var regularExpression = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!£@#$%^&*()_\-+=\[\]{};:'",.<>?\/\\|`~])[A-Za-z\d!£@#$%^&*()_\-+=\[\]{};:'",.<>?\/\\|`~]{8,}$/;


    if (!regularExpression.test(value)) {
            return "The password must have minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character";
    }
    return true;
},
  username: [
    v => !!v || 'Username is required',
    // v => /.+@.+/.test(v) || 'E-mail must be valid'
  ],
  email: [
    v => !!v || 'Email is required',
    v => /.+@.+/.test(v) || 'E-mail must be valid'
  ],
  account: {
    name: [
      v => !!v || 'Account Name is required',
      v => (v && v.length < 25) || 'Name must be less than 25 characters'
    ],
    surname: [
      v => !!v || 'Account Surname is required',
      v => (v && v.length < 25) || 'Surname must be less than 25 characters'
    ],
    role: [
      v => !!v || 'Account Role is required'
    ],
    status: [
      v => !!v || 'Account Status is required'
    ],
    password: [
      v => !!v || 'Password is required',
      v => (v && v.length >= 8) || 'The password must have at least 8 characters',
      // v => (v && v.toLowerCase() != v) || 'The password must have at one uppercase character'
    ]
  },
  company: {
    name: [
      v => !!v || 'Company Name is required',
      v => (v && v.length < 25) || 'Name must be less than 25 characters'
    ],
  },
  company_user: {
    name: [
      v => !!v || 'Company User Name is required',
      v => (v && v.length < 25) || 'Name must be less than 25 characters'
    ],
    company: [
      v => !!v || 'Company is required'
    ]
  },
  company_has_protocol: {
    protocol: [
      v => !!v || 'Protocol is required'
    ],
    company: [
      v => !!v || 'Company is required'
    ]
  },
  protocol: {
    name: [
      v => !!v || 'Protocol Name is required',
      v => (v && v.length < 25) || 'Name must be less than 25 characters'
    ],
    sponsor: [
      v => !!v || 'Sponsor is required'
    ],
    provider: [
      v => !!v || 'Provider is required'
    ],
    external_name: [
      v => !!v || 'External name is required'
    ]
  },
  site: {
    protocol: [
      v => !!v || 'Protocol is required'
    ],
    name: [
      v => !!v || 'Site Name is required',
      v => (v && v.length < 255) || 'Name must be less than 255 characters'
    ],
    country: [
      v => !!v || 'Country Site is required'
    ],
    code: [
      v => !!v || 'Site Code is required'
    ],
    city: [
      v => !!v || 'Site City is required'
    ]
  },
  protocol_site: {
    protocol: [
      v => !!v || 'Protocol is required'
    ],
    code: [
      v => !!v || 'Site Code is required'
    ],
    site: [
      v => !!v || 'Site is required'
    ]
  },
  treatment: {
    protocol: [
      v => !!v || 'Protocol is required'
    ],
    drug: [
      v => !!v || 'Treatment Drug is required'
    ],
    dose: [
      v => !!v || 'Treatment Dose is required'
    ],
    measure_unit: [
      v => !!v || 'Measure unit is required'
    ]
  },
  external_user: {
    protocol: [
      v => !!v.length || 'Protocol is required'
    ],
    type: [
      v => !!v || 'Type is required'
    ],
    name: [
      v => !!v || 'External User Name is required',
      v => (v && v.length < 25) || 'Name must be less than 25 characters'
    ],
    email: [
      v => !!v || 'Email is required',
      v => /.+@.+/.test(v) || 'E-mail must be valid'
    ]
  },
  sae: {
    protocol: [
      v => !!v || 'Protocol is required'
    ],
    patient: [
      v => !!v || 'Patient is required'
    ],
    site: [
      v => !!v || 'Site is required'
    ],
    ae_onset_date: [
      v => !!v || 'Onset Date is required'
    ],
    case_type: [
      v => !!v || 'Case type is required'
    ],
    receipt_date: [
      v => !!v || 'Receipt Date is required'
    ],
    serious_criteria: [
      v => !!v  || 'Serious Criteria is required'
    ],
    ae_verbatim_reported: [
      v => !!v || 'Verbatim reported is required'
    ]
  },
  pregnancy: {
    protocol: [
      v => !!v || 'Protocol is required'
    ],
    patient: [
      v => !!v || 'Patient is required'
    ],
    site: [
      v => !!v || 'Site is required'
    ],
    case_type: [
      v => !!v || 'Case type is required'
    ],
    receipt_date: [
      v => !!v || 'Receipt Date is required'
    ],
    start_date_last_menses: [
      v => !!v || 'Start date of last menses is required'
    ]
  },
  spm: {
    protocol: [
      v => !!v || 'Protocol is required'
    ],
    patient: [
      v => !!v || 'Patient is required'
    ],
    site: [
      v => !!v || 'Site is required'
    ],
    case_type: [
      v => !!v || 'Case type is required'
    ],
    report_date: [
      v => !!v || 'Report Date is required'
    ],
  }
}
